module.exports = __webpack_public_path__ + "static/search-background-2a07be824827b23e791d77ba725829d4.jpg";